import { Link } from 'react-router-dom';
import { FileText, ArrowRight } from 'lucide-react';
import { SimpleLayout, ST } from '../components/SimpleLayout';

export function TermsPage() {
  return (
    <SimpleLayout>
      <section
        style={{
          maxWidth: 720,
          margin: '0 auto',
          padding: '96px 24px 48px',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 72,
            height: 72,
            borderRadius: 20,
            background: ST.primarySoft,
            color: ST.primary,
            marginBottom: 24,
          }}
        >
          <FileText size={32} />
        </div>
        <h1
          style={{
            fontSize: 'clamp(34px, 4vw, 48px)',
            fontWeight: 800,
            letterSpacing: -1.4,
            margin: '0 0 12px 0',
            color: ST.text,
          }}
        >
          Regulamin
        </h1>
        <p
          style={{
            fontSize: 17,
            color: ST.textMuted,
            lineHeight: 1.6,
            margin: '0 0 32px 0',
          }}
        >
          Treść regulaminu pojawi się wkrótce. Pracujemy nad finalną wersją dokumentu.
        </p>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            padding: '10px 16px',
            borderRadius: 999,
            background: ST.surface,
            border: `1px solid ${ST.border}`,
            color: ST.textMuted,
            fontSize: 14,
            marginBottom: 32,
          }}
        >
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: 999,
              background: ST.accent,
              display: 'inline-block',
            }}
          />
          Status: w przygotowaniu
        </div>
        <div>
          <Link
            to="/"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '12px 22px',
              borderRadius: 12,
              background: ST.primary,
              color: '#fff',
              fontSize: 15,
              fontWeight: 600,
              textDecoration: 'none',
            }}
          >
            Wróć na stronę główną <ArrowRight size={16} />
          </Link>
        </div>
        <p
          style={{
            fontSize: 13,
            color: ST.textSubtle,
            marginTop: 40,
          }}
        >
          Pytania?{' '}
          <a
            href="mailto:support@marmocar.pl"
            style={{ color: ST.primary, textDecoration: 'none', fontWeight: 500 }}
          >
            support@marmocar.pl
          </a>
        </p>
      </section>
    </SimpleLayout>
  );
}
